import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {Box, Button, Divider, Paper} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import CollapseButton from './collapse-button.jsx';
import ScrollingTitle from '@explorer/components/ui/scrolling-title';

const LeftDrawerHeader = ({
  title,
  children,
  collapse = true,
  collapseTitle,
  onBackClick,
  icon,
  subHeader,
  backButtonProps = {},
  showBackButton,
  ...props
}) => {
  return (
    <Paper
      elevation={2}
      square
      sx={theme => ({
        boxShadow: 'none',
        paddingTop: 2,
        ...theme.applyStyles('light', {
          backgroundColor: 'grey.100',
        }),
      })}
      {...props}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingLeft: 2,
          paddingRight: 1,
          marginBottom: 1,
        }}
      >
        {icon}
        {title && (
          <ScrollingTitle
            variant="h6"
            component="h2"
            color="textPrimary"
            sx={{marginLeft: 1}}
          >
            {title}
          </ScrollingTitle>
        )}
        {collapse && <CollapseButton direction="left" title={collapseTitle} />}
      </Box>
      <Divider />
      {(showBackButton || (!!onBackClick && !!subHeader)) && (
        <React.Fragment>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginY: 1,
            }}
          >
            {onBackClick && (
              <Box
                sx={{
                  marginX: 0.5,
                }}
              >
                <Button
                  color="primary"
                  onClick={onBackClick}
                  {...backButtonProps}
                  startIcon={<ArrowBackIcon />}
                  size="small"
                >
                  Back
                </Button>
              </Box>
            )}
            {subHeader && (
              <>
                <Divider orientation="vertical" flexItem />
                <ScrollingTitle data-qe="sidebar-subheader" sx={{marginX: 1}}>
                  {subHeader}
                </ScrollingTitle>
              </>
            )}
          </Box>
          <Divider flexItem />
        </React.Fragment>
      )}
    </Paper>
  );
};

LeftDrawerHeader.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  action: PropTypes.node,
  collapseTitle: PropTypes.string,
  collapse: PropTypes.bool,
  icon: PropTypes.element,
  onBackClick: PropTypes.func,
  subHeader: PropTypes.string,
  backButtonProps: PropTypes.object,
  showBackButton: PropTypes.bool,
};

export default LeftDrawerHeader;
